import { Mail, Phone } from 'lucide-react';

interface ContactCardMobileProps {
  label: string;
  name: string;
  email: string;
  phone: string;
}

const ContactCardMobile = ({
  label,
  name,
  email,
  phone,
}: ContactCardMobileProps) => {
  return (
    <div className="flex w-full flex-col gap-3 rounded-[10px] bg-surface-inverse p-[18px] px-4">
      <span className="font-body text-[10px] font-semibold uppercase tracking-[0.5px] text-accent-primary">
        {label}
      </span>
      <span className="font-heading text-base font-medium text-foreground-inverse">
        {name}
      </span>
      <div className="flex flex-col gap-2">
        <a
          href={`mailto:${email}`}
          className="flex items-center gap-2 rounded-lg border border-white/20 px-3 py-2 transition-colors hover:border-white/40"
        >
          <Mail className="h-3.5 w-3.5 text-white/80" />
          <span className="font-body text-xs text-foreground-inverse">
            {email}
          </span>
        </a>
        <a
          href={`tel:${phone}`}
          className="flex items-center gap-2 rounded-lg border border-white/20 px-3 py-2 transition-colors hover:border-white/40"
        >
          <Phone className="h-3.5 w-3.5 text-white/80" />
          <span className="font-body text-xs text-foreground-inverse">
            {phone}
          </span>
        </a>
      </div>
    </div>
  );
};

export default ContactCardMobile;
